// import { useContext } from 'react';

// import { UserContext } from '../../contexts/user.context';
import { useNavigate } from "react-router-dom";

import { Button } from 'antd';
import { signInWithGooglePopup, signOutUser } from '../../utils/firebase.utils';


import { 
	SignOutContainer
 } from "./signout.styles";

const SignOut = () => {
    const navigate = useNavigate();

	const handleSignOut = () => {
		signOutUser();
		navigate("../"); 
	};

	return(
		<SignOutContainer>
            <Button onClick={handleSignOut}>Sign Out</Button>
		</SignOutContainer>
	);
}

export default SignOut;